export default "__VITE_ASSET__38078f98__"